<section class="header">
    <nlr-header></nlr-header>
</section>

<section
    id="inner"
    class="content">
    <div
        class="container-fluid lodge-field-record"
        cg-busy="$ctrl.appPromises">
        @if (hasLodgeFieldRecordPermission()) {
            <div>
                <div class="h4">
                    <span>Field Record Information</span>
                    <div class="pull-right">
                        <span>
                            <i
                                class="nlrp-icon nlrp-icon-zoom-out"
                                alt="Decrease font size"
                                id="decreaseFontBtn"
                                title="Decrease font size within my dashboard"
                                (click)="adjustFontSize(-2)"
                                tabindex="0"></i>
                        </span>
                        <span>
                            <i
                                class="nlrp-icon nlrp-icon-zoom-in"
                                alt="Increase font size"
                                id="increaseFontBtn"
                                title="Increase font size within my dashboard"
                                (click)="adjustFontSize(2)"
                                tabindex="0"></i>
                        </span>
                    </div>
                </div>
                <form
                    class="lodgeFieldRecordForm"
                    #lodgeFieldRecordForm="ngForm"
                    name="lodgeFieldRecordForm">
                    @if (showSurveyorDetails()) {
                        <nlr-plan-surveyor-details
                            #surveyorDetailsForm
                            [model]="model"
                            (validationChanged)="updateValidationResult(0, $event)"
                            (modelChanged)="onModelChanged($event)"></nlr-plan-surveyor-details>
                    }
                    @if (showFieldRecordLodgement()) {
                        <nlr-plan-field-record-lodgement
                            #fieldRecordLodgeForm
                            [model]="model"
                            [lodgeTypes]="fieldRecordLodgementTypes"
                            (validationChanged)="updateValidationResult(1, $event)"
                            (modelChanged)="onModelChanged($event)"></nlr-plan-field-record-lodgement>
                    }
                    @if (showFieldRecordDetails()) {
                        <nlr-plan-field-record-details
                            #fieldRecordDetailsForm
                            [model]="model"
                            [fieldRecordPurposes]="fieldRecordPurposes"
                            (validationChanged)="updateValidationResult(2, $event)"
                            [formerTenureSubjectOfPlans]="formerTenureSubjectOfPlans"
                            (modelChanged)="onModelChanged($event)"></nlr-plan-field-record-details>
                    }
                    @if (showFieldRecordSubjectPlans()) {
                        <nlr-field-record-subject-plans
                            #fieldRecordSubjectPlans
                            [model]="model"
                            [planTypes]="planTypes"
                            (validationChanged)="updateValidationResult(3, $event)"
                            [selectedPurpose]="getSelectedPurpose()"
                            [selectedLodgementType]="getSelectedLodgementType()"></nlr-field-record-subject-plans>
                    }
                    @if (showFieldRecordFormerTenure()) {
                        <nlr-field-record-former-tenure
                            #fieldRecordFormerTenure
                            [model]="model"
                            [parentPlanTypes]="parentPlanTypes"
                            [formerTenureSubjectOfPlans]="formerTenureSubjectOfPlans"
                            (validationChanged)="updateValidationResult(4, $event)"
                            [selectedLodgementType]="getSelectedLodgementType()"
                            [selectedPurpose]="getSelectedPurpose()"></nlr-field-record-former-tenure>
                    }
                    @if (showFieldRecordLocalities()) {
                        <nlr-field-record-localities
                            #fieldRecordLocalitiesForm
                            [ngModel]
                            [model]="model"
                            [planTypes]="planTypes"
                            [formerTenureSubjectOfPlans]="formerTenureSubjectOfPlans"
                            [selectedLodgementType]="getSelectedLodgementType()"
                            [selectedPurpose]="getSelectedPurpose()"></nlr-field-record-localities>
                    }
                    @if (showFieldRecordAddress()) {
                        <nlr-field-record-address
                            #fieldRecordAddressForm
                            [model]="model"
                            [selectedLodgementType]="getSelectedLodgementType()"
                            [selectedPurpose]="getSelectedPurpose()"></nlr-field-record-address>
                    }
                    @if (showFieldRecordSurveyDetails()) {
                        <nlr-field-record-survey-details
                            #fieldRecordSurveyDetails
                            [model]="model"
                            [selectedPurpose]="getSelectedPurpose()"></nlr-field-record-survey-details>
                    }
                    @if (showFieldRecordAttachments()) {
                        <nlr-field-record-attachments
                            #fieldRecordAttachments
                            [model]="model"
                            [selectedPurpose]="getSelectedPurpose()"></nlr-field-record-attachments>
                    }
                    @if (showFieldRecordWapc()) {
                        <nlr-field-record-wapc
                            #fieldRecordWapcForm
                            [model]="model"
                            [selectedPurpose]="getSelectedPurpose()"
                            [selectedLodgementType]="getSelectedLodgementType()"></nlr-field-record-wapc>
                    }
                    <div class="row">
                        <div class="col-xs-12">
                            <div
                                class="btn-toolbar"
                                role="toolbar"
                                aria-label="...">
                                <div
                                    class="btn-group"
                                    role="group"
                                    aria-label="...">
                                    <button
                                        type="submit"
                                        class="btn btn-default nlr-btn-sm validate"
                                        (click)="save()"
                                        ng-disabled="$ctrl.isSubmitDisabled()"
                                        title="Submit"
                                        >Submit</button
                                    >
                                </div>
                                <div
                                    class="btn-group"
                                    role="group"
                                    aria-label="...">
                                    <button
                                        type="button"
                                        class="btn btn-default nlr-btn-sm validate"
                                        (click)="cancel()"
                                        title="Cancel"
                                        >Cancel</button
                                    ></div
                                >
                            </div>
                        </div>
                    </div>
                </form>
            </div>
        }
        @if (!hasLodgeFieldRecordPermission()) {
            <div>
                <h1>You do not have permission to lodge field records</h1>
            </div>
        }
    </div>
</section>

<section class="footer">
    <nlr-footer></nlr-footer>
</section>
